import React from 'react'
import i18n from 'i18next'

import Button from '../../../../UniformComponents/Button'

const QuestionEdit = ({ reportStore, pageId }) => {
    const { appStore, emSurveyUser } = reportStore
    const { survey } = appStore

    if (!reportStore.emSurveyUser) return null

    const surveyPageURL = `${survey.getUserLink(emSurveyUser, true)}&pageId=${pageId}&noCache=1&pageOnly=true`

    return (
        <Button
            label={i18n.t('report_updateAnswers')}
            cssClass="regular tertiary"
            onClick={() => reportStore.editResponse(surveyPageURL)}
            icon="fa-regular fa-pen-to-square"
        />
    )
}

export default QuestionEdit
